import React from 'react';

import { Container } from 'Components/Utilities';
import { Link } from 'react-router-dom';
import { asset, filterItemsByAccess } from 'Services/BaseHelpers';
import User from 'Services/User';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import AdminGroupSelect from "Components/Partials/AdminGroupSelect";

export default class Unauthenticated extends React.Component {
    /**
     * @method render
     * @returns {JSX.Element}
     */
    render () {
        const {children, pageTitle} = this.props;

        return (
            <div className="min-h-screen flex flex-col justify-between bg-white font-light">
                <div className={`
                bg-white text-black px-8 py-10 lg:py-4 select-none flex items-center flex-wrap lg:flex-nowrap mb-4
            `}>
                <Link to="/">
                    <img src={asset('images/header-logo.png')} className={"w-96"} alt={"Boots and No7 logo"}/>
                </Link>

            </div>

                <div className={"px-8 py-10 "}>
                    {children}
                </div>

                <div className="text-white pt-8">
                    <a href="https://www.boots.com/floating-editorial/editorial-legal/privacypolicy" target="_blank">
                        Privacy Policy
                    </a>
                </div>
            </div>
        );
    }
}
